import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from 'lucide-react';
import { ArrowLeft } from 'lucide-react';

const config = {
  cUrl: "https://api.countrystatecity.in/v1/countries/IN",
  ckey: "NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA==",
};

const StateSelector = () => {
  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoadingStates, setIsLoadingStates] = useState(false);
  const navigate = useNavigate();



 

  const handleSelect = () => {
    if (selectedState) {
      alert(`You selected: ${selectedState.name}`);
    }
  };

  const [isVisible, setVisible] = useState(false)
  const id = localStorage.getItem('userId')

  useEffect(() => {

    if (id && id.startsWith('VC-')) {
      setVisible(false)
    }
    else{
      setVisible(true) 
    }

  }, [id])

  return (
    <div className="min-h-screen h-screen flex flex-col bg-white font-satoshi">
      <div onClick={() => navigate(-1)}
        className=" top-2 left-2 text-black rounded-full p-2 cursor-pointer">
        <ArrowLeft />
      </div>
      <div className="flex-1 overflow-y-auto px-4 py-2">
        <div
          style={{ borderBottom: '1px solid gray' }}
          className="flex items-center justify-between py-4 border-b cursor-pointer font-bold"
          onClick={() => { navigate('/user-profile-details') }}

        >
          Profile
          <ChevronRight />
        </div>
        <div
          style={{ borderBottom: '1px solid gray' }}
          className="flex items-center justify-between py-4 border-b cursor-pointer font-bold"
          onClick={() => { navigate('/crane-user-all-cases') }}
        >

          View Order
          <ChevronRight />

        </div>

        <div
          hidden={isVisible}

          style={{ borderBottom: '1px solid gray' }}
          className="flex items-center justify-between py-4 border-b cursor-pointer font-bold"
          onClick={() => { navigate('/AllAddedVehiclesNew') }}
        >

          Add Vehicles
          <ChevronRight />

        </div>

      </div>

      {/* Select Button */}

    </div>
  );
};

export default StateSelector;
